import React, { useContext } from "react";
import FormTitle from "../atoms/FormTitle";
import ExplanationText from "../atoms/ExplanationText";
import ContentContainer from "../atoms/ContentContainer";
import InputItem from "../atoms/InputItem";
import InputWrapper from "../atoms/InputWrapper";
import ChevronRight from "../atoms/icons/ChevronRight";
import { firstError } from "../../Services/Form";
import { UserContext } from "../Context/UserContext";
const EnterDebtorNumber = ({ loading, errors, credentials, onSubmit: handleSubmit, onChange: handleChange, onBackward: handleBackButton, }) => {
    const { user } = useContext(UserContext);
    return (React.createElement("form", { onSubmit: handleSubmit },
        React.createElement(ContentContainer, { loading: loading, hasMandatoryExplanationText: true, hasFooterActions: true, hasNextButtonIconRight: true, backButtonHandle: handleBackButton, nextButtonIcon: React.createElement(ChevronRight, null), nextButtonText: "Informatie aanvullen" },
            React.createElement(FormTitle, null,
                "Informatieverzoek openen ", user === null || user === void 0 ? void 0 :
                user.id),
            React.createElement(ExplanationText, null, "Voer alstublieft het debiteurnummer in dat hoort bij het informatieverzoek. Dit nummer staat vermeld in de brief die u heeft ontvangen."),
            React.createElement(InputWrapper, null,
                React.createElement(InputItem, { disabled: loading, error: firstError(errors.debtor_number), onChange: handleChange, value: credentials.debtor_number, name: "debtor_number", type: "text", label: "Debiteurnummer", isMandatory: true })))));
};
export default EnterDebtorNumber;
